import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/admin/layouts/Sidebar';
import Header from '../../components/admin/layouts/Header';
import { Content } from 'antd/es/layout/layout';

const AdminLayout: React.FC = () => {
    return (
        <Layout className="min-h-screen">
            <Sidebar />
            <Layout className="site-layout ml-[250px] min-h-screen">
                <Header />
                <Content
                    style={{
                        margin: '84px 16px 24px',
                        border: '1px solid #f0f2f5',
                        borderRadius: 8,
                        background: '#fff',
                    }}
                >
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
};

export default AdminLayout;